import router from '@/router'
import { mapState } from 'vuex'
import axios from 'axios'
export default {
    data() {
        return {}
    },
    computed: {
        ...mapState([
            'vuex_relevance_company',
            'vuex_userInfo',
            'vuex_isLogin',
            'vuex_token',
            'vuex_userId',
            'vuex_cart_skip_type',
            'vuex_default_img',
            'vuex_compare_popup_list',
            'vuex_compare_popup_list_detail',
        ]),
        // 计算总价（单价，数量）
        mix_mathPrice() {
            return (price, num) => {
                function roundToTwoDecimals(num) {
                    return Number(Math.round(num + 'e2') + 'e-2').toFixed(2)
                }
                function calculateTotalPrice(unitPrice, quantity) {
                    // 先进行乘法运算
                    const total = Number(unitPrice) * Number(quantity)
                    // 使用 toFixed(2) 方法进行四舍五入并保留两位小数
                    // 然后将结果转换回数字类型
                    // return parseFloat(total.toFixed(2))
                    return roundToTwoDecimals(total)
                }
                if (price == 0 || price == '0.00' || price == '0') {
                    return '0.00'
                }
                if (num == 0) {
                    return '0.00'
                }
                return calculateTotalPrice(price, num)
            }
        },
        // 四舍五入、保留两位小数
        mix_roundToTwoDecimals() {
            function roundToTwoDecimals(num) {
                return Number(Math.round(num + 'e2') + 'e-2').toFixed(2)
            }
            return (num) => {
                if (!num || num == '0' || num == '0.00' || num == 0) {
                    return '0.00'
                }
                return roundToTwoDecimals(num)
            }
        },
        // 传入2025-09-14 17:03:45，返回2025-09-14
        mix_dateTime_to_date() {
            return (dateTime) => {
                function formatDateTimeToDate(datetimeStr) {
                    // 检查输入是否为有效的字符串
                    if (typeof datetimeStr !== 'string') {
                        throw new Error('输入必须是字符串类型')
                    }

                    // 使用空格分割日期和时间部分
                    const [datePart] = datetimeStr.split(' ')

                    // 验证日期格式是否符合 YYYY-MM-DD
                    const dateRegex = /^\d{4}-\d{2}-\d{2}$/
                    if (!dateRegex.test(datePart)) {
                        throw new Error('日期格式不符合 YYYY-MM-DD')
                    }

                    return datePart
                }

                if (!dateTime) {
                    return
                }

                return formatDateTimeToDate(dateTime)
            }
        },
    },
    created() {},
    mounted() {},
    destroyed() {},
    methods: {
        mix_setVuex(k, v) {
            this.$store.commit('set_vuex_data', {
                k,
                v,
            })
        },
        // 获取用户信息
        mix_getUserInfo() {
            return new Promise(async (resolve, reject) => {
                this.$api('users_userInfo', {
                    userId: this.vuex_userId,
                    token: this.vuex_token,
                }).then((res) => {
                    this.$load.close()
                    if (res.code == 200) {
                        this.$store.commit('set_vuex_data', {
                            k: 'vuex_userInfo',
                            v: res.data,
                        })
                        this.$store.commit('set_vuex_data', {
                            k: 'vuex_isLogin',
                            v: true,
                        })
                        if (res.data.companyId == 0) {
                            // 未关联公司
                            if (res.data.companyApplyStep == 1) {
                                // 已填写完成表单
                                if (res.data.companyApplyStatus == 1) {
                                    // 已填写、审核中
                                    this.$store.commit('set_vuex_data', {
                                        k: 'vuex_relevance_company',
                                        v: 1,
                                    })
                                } else if (res.data.companyApplyStatus == 2) {
                                    // 已填写、通过
                                    this.$store.commit('set_vuex_data', {
                                        k: 'vuex_relevance_company',
                                        v: 2,
                                    })
                                } else if (res.data.companyApplyStatus == -1) {
                                    // 已填写、驳回
                                    this.$store.commit('set_vuex_data', {
                                        k: 'vuex_relevance_company',
                                        v: 3,
                                    })
                                } else {
                                    // 没填写过表单
                                    this.$store.commit('set_vuex_data', {
                                        k: 'vuex_relevance_company',
                                        v: 0,
                                    })
                                }
                            } else {
                                // 未填写完成表单
                                this.$store.commit('set_vuex_data', {
                                    k: 'vuex_relevance_company',
                                    v: 0,
                                })
                            }
                        } else {
                            // 已经关联公司
                            this.$store.commit('set_vuex_data', {
                                k: 'vuex_relevance_company',
                                v: 2,
                            })
                        }
                        resolve(res.data)
                    } else {
                        this.$store.commit('set_vuex_data', {
                            k: 'vuex_userInfo',
                            v: {},
                        })
                        this.$store.commit('set_vuex_data', {
                            k: 'vuex_isLogin',
                            v: false,
                        })
                        alertErr(res.msg)
                        resolve(false)
                    }
                })
            })
        },
        // 获取关联公司详情
        mix_getCompanyDetail() {
            return new Promise(async (resolve, reject) => {
                this.$api('company_companyDetail', {}).then((res) => {
                    if (res.code == 200) {
                        resolve(res.data)
                    } else {
                        alertErr(res.msg)
                        resolve(false)
                    }
                })
            })
        },
        // 添加购物车
        mix_addCar(inventoryId, num) {
            return new Promise(async (resolve, reject) => {
                this.$api('gouwuche_add', {
                    inventoryId: inventoryId,
                    num: num,
                }).then((res) => {
                    if (res.code == 200) {
                        let userInfo = this.$cloneDeep(this.vuex_userInfo)
                        userInfo['cartNum'] = res.data.count
                        this.mix_setVuex('vuex_userInfo', userInfo)
                        resolve(res.data)
                    } else {
                        alertErr(res.msg)
                        resolve(false)
                    }
                })
            })
        },
        // 获取省市区
        mix_getLocalData(id = '') {
            return new Promise(async (resolve, reject) => {
                this.$api('users_getAreaList', {
                    parent_id: id,
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res.data)
                    } else {
                        alertErr(res.msg)
                        resolve(false)
                    }
                })
            })
        },
        // 获取地址簿：type：1邮寄地址，2收货地址,3开票地址
        mix_getUserAddress(type = 1) {
            return new Promise(async (resolve, reject) => {
                this.$api('userAddress_lists', {}).then((res) => {
                    if (res.code == 200) {
                        if (this.$isArray(res.data) && res.data.length > 0) {
                            // 配置过地址
                            let obj = false
                            for (let index = 0; index < res.data.length; index++) {
                                let item = res.data[index]
                                if (item.type == type) {
                                    obj = item
                                    break
                                }
                            }
                            if (obj) {
                                resolve(obj)
                            } else {
                                resolve(false)
                            }
                        } else {
                            // 没有配置过地址
                            resolve(false)
                        }
                    } else {
                        alertErr(res.msg)
                        resolve(false)
                    }
                })
            })
        },
        // 获取网站信息
        async mix_get_index_config() {
            return new Promise(async (resolve, reject) => {
                this.$api('index_config', {}).then((res) => {
                    if (res.code == 200) {
                        resolve(res.data)
                    } else {
                        alertErr(res.msg)
                        resolve(false)
                    }
                })
            })
        },
    },
}
